import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
  Grid,
  TextField,
  Dialog,
  DialogContent,
  Switch,
  DialogTitle,
  Card,
} from '@material-ui/core';
import { createPermissionConfigApi, updatePermissionConfigApi } from 'api';
import permissionsNames from './PermissionsNames';


const useStyles = makeStyles(() => ({
  permissionItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
  }
}));

const EditPermissionConfigModal = ({generalPermissions = {}, configData, setOpen}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [changedConfigData, setChangedConfigData] = useState(configData);
  const { permissions } = changedConfigData;

  const handleSaveConfig = () => {
    if (changedConfigData._id) {
      updatePermissionConfigApi({ dispatch, permissionConfig: changedConfigData });
    } else {
      createPermissionConfigApi({ dispatch, permissionConfig: changedConfigData });
    }

    setOpen(false);
  };

  const handleChangePermissionStatus = (event) => {
    const {name, checked} = event.target;
    setChangedConfigData((configData) => ({ ...configData, permissions: { ...configData.permissions, [name]: checked } }));
  };

  const handleChangeConfigName = (event) => {
    const {value} = event.target;
    setChangedConfigData((configData) => ({ ...configData, name: value }));
  };

  return (
    <Dialog
      open={!!configData}
      onClose={() => setOpen(false)}
      aria-labelledby="edit-config"
      fullWidth
      maxWidth={'md'}
    >
      <DialogTitle
        id="edit-config"
      >
        {changedConfigData._id ? 'Edit Config' : 'Create Config'}
      </DialogTitle>
      <DialogContent
        className="px-8"
      >
        <Grid item xs={12} className="mt-5 mb-10 flex items-center">
          <Grid item xs={12} sm={4} md={3}>Config Name:</Grid>
          <Grid item xs={12} sm={8} md={9}>
            <TextField
              fullWidth
              required
              name="Config Name"
              value={changedConfigData.name}
              onChange={handleChangeConfigName}
            />
          </Grid>
        </Grid>
        <Grid container className="flex items-center" spacing={3}>
          {Object.keys(permissions).map((keyName) => {
            return (
              <Grid key={keyName} item xs={12} sm={6} md={3}>
                <Card className={classes.permissionItem} fullWidth>
                  {permissionsNames[keyName] || keyName} <span className="text-white">{permissions[keyName] === generalPermissions[keyName] ? '+' : '-'}</span>
                  <Switch
                    color="primary"
                    name={keyName}
                    checked={permissions[keyName]}
                    onChange={(event) => handleChangePermissionStatus(event)}
                  />
                </Card>
              </Grid>
            );
          })}
        </Grid>
        <Grid container className="mt-8 pb-4 flex items-center justify-between">
          <Button
            color="primary"
            variant="contained"
            className="capitalize"
            onClick={handleSaveConfig}
          >
            Save Config
          </Button>
          <Button
            variant="contained"
            onClick={() => setOpen(false)}
          >
            Cancel
          </Button>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default EditPermissionConfigModal;
